import React from "react";

import { TableBody, TableCell, TableRow } from "../helper";
import ChallanTableGenericRow from "./ChallanTableGenericRow";

export default function ChallanTableBody({ columnConfig, rows, uid, params }) {
  return (
    <TableBody>
      {rows.map((row) => (
        <ChallanTableGenericRow
          columnConfig={columnConfig}
          key={row[uid]}
          row={row}
        />
      ))}
      {rows.length === 0 && (
        <TableRow>
          <TableCell colSpan={columnConfig.length}>
            <h1
              style={{
                width: "100%",
                margin: 0,
                fontSize: 18,
                textAlign: "center",
              }}
            >
              {params.economicCode === "ALL"
                ? "Click on 'Download as csv' for downloading all economic code data"
                : "No data available."}
            </h1>
          </TableCell>
        </TableRow>
      )}
    </TableBody>
  );
}
